<template>
<div class="box" v-loading="loading2"
     element-loading-text="拼命加载中"
     element-loading-spinner="el-icon-loading"
     element-loading-background="rgba(0, 0, 0, 0.8)"
>
  <div id="lydom">
  <div class="asstsCard">
    <p class="asstsCardTitle">总资产</p>
    <div v-if="bjstatus && tagName === '' && urlly === 'cx' && !jtmoshi" class="asstsCardClick" @click="bjit" style="color: #F8E71C;">标记他有奖励</div>
    <div v-if="bjstatus && tagName === '' && urlly !== 'cx' && !jtmoshi" class="asstsCardClick" @click="bjit" >标记他</div>
    <div v-if="bjstatus && tagName !== ''" class="asstsCardClick">{{tagName}}<span v-if="!jtmoshi" @click="bjit">修改</span></div>
    <p class="asstsCardNum">{{allprice}}<span>USD</span></p>
    <p class="asstsCardAddres">{{walletAddress}}</p>
    <p class="asstsCardNowTips" v-if="tagInfo.length === 1">被{{tagInfo[0].count}}人标记为“{{tagInfo[0].name}}”</p>
    <p class="asstsCardNowTips" v-if="tagInfo.length === 2">被{{tagInfo[0].count}}人标记为“{{tagInfo[0].name}}” {{tagInfo[1].count}}人标记为“{{tagInfo[1].name}}”</p>
  </div>
  <div class="dataUpdataTime">
    <p>数据更新于 {{createTime}}</p>
    <a v-if="!jtmoshi" v-clipboard:copy="walletAddress"
       v-clipboard:success="onCopy"
       v-clipboard:error="onError">复制地址</a>
  </div>
  <div class="B_list" >
    <div :key="item.key"  v-for="item in tokenList" v-if="item.name !== ''">
      <img crossOrigin='anonymous' @error="imgLoadError($event)" @load="imgLoad($event,item.key)" v-bind:src="item.logoUrl === '' ? 'http://images.growup.link/tokenLogo/default.png' : item.logoUrl"/>

      <div class="tipleft">
        <p v-if="item.symbol !== ''">{{item.symbol}}</p>
        <p v-if="item.symbol === ''">{{item.name}}</p>
        <span v-if="item.symbol !== ''">{{item.name}}</span>
      </div>
      <div class="tipright">
        <p>{{item.bs}}</p>
        <span v-if="item.price !== '0'">≈{{(item.balance * item.price).toFixed(2)}} USD</span>
        <span v-if="item.price === '0'">~</span>
      </div>
    </div>
    <div></div>
    <div></div>
  </div>
  <img v-show="jtmoshi" src="/static/xcx.png" style="position: absolute;width: 2.5rem;left: 50%;transform: translateX(-50%);bottom: 0rem;"/>
  </div>
  <div class="bottom_box1">
  </div>
  <div class="bottom_box">
    <a  class="downloadButton" @click="fxfriedn">分享给朋友</a>
    <img class="downloadButtonShadow" src="/static/downloadshadow.png">
  </div>
  <div class="fxfriedn" v-if="popoverStatus" >
    <div class="popover">
      <div class="top">
        <a @click="share">
          分享给朋友
        </a>
        <a style="border-top: 0.013rem solid rgba(0,0,80,0.85);" @click="getHtml2canvas">
          生成分享图片
        </a>
      </div>
      <div class="bottom">
        <a style="border-top: 0.013rem solid rgba(0,0,80,0.85);" @click="quit">
          取消
        </a>
      </div>
    </div>
  </div>
  <div class="bj_box" v-if="bjStatus">
      <div>
        <p v-if="tagName === '' && urlly === 'cx'" class="tip1">标记他有奖励</p>
        <p v-if="tagName === '' && urlly !== 'cx'" class="tip1">标记他</p>
        <p v-if="tagName !== ''" class="tip1">修改标记</p>
        <p v-if="tagName === '' && urlly === 'cx'" class="tip2">标记成功奖一次查询机会</p>
        <p v-if="urlly !== 'cx' && tagInfo.length !== 0" class="tip2">被{{tagInfo[0].count}}人标记为“{{tagInfo[0].name}}”</p>
        <div class="bjNameIuput">
            <input ref="bjNameIuput" type="text"  @focus="xsclearbutton" @blur="ycclearbutton"  placeholder="这位土豪是谁？(4个字内）" />
            <a v-if="clearbutton" @click="clearInputValue"  ></a>
          </div>
          <div class="bottom_button">
            <a @click="quitbjbox">取消</a>,
            <a @click="goTag">确定</a>
          </div>
      </div>
  </div>
  <div class="successTip" v-if="TipStutas">
    {{TipStutasText}}
  </div>
  <div class="shareTip" v-if="shareStutas" @click="quitShare"></div>
  <div class="canvas_box" v-show="tpbjj">
    <img v-bind:src="imgDown"/>
    <div class="tipss">长按图片进行保存</div>
    <canvas id="canvas" style="display: none" ></canvas>
  </div>
</div>
</template>

<script>
import Config from '../config/index'
import callApi from '../../static/callApi'
import qs from 'qs'
import html2canvas from 'html2canvas'
import _ from 'lodash'
export default {
  name: 'asstsQuery',
  data () {
    return {
      popoverStatus: false,
      bjStatus: false,
      TipStutas: false,
      TipStutasText: '',
      bjType: '1',
      clearbutton: false,
      urlly: '',
      cxAsstsId: '',
      tokenList: '',
      allprice: '',
      tagInfo: [],
      tagName: '',
      loading2: false,
      createTime: '',
      walletAddress: '',
      tpbjj: false,
      jtmoshi: false,
      tokenListBak: '',
      imgDown: '',
      shareStutas: false,
      uuid: '',
      uid: '',
      token: '',
      bjstatus: true
    }
  },
  created: function () {
    if (this.$route.query.bjstatus === 'no') {
      this.bjstatus = false
    }
    if (this.$route.query.cxAsstsId) {
      this.loading2 = true
      this.cxAsstsId = this.$route.query.cxAsstsId
      this.token = this.$route.query.token
      this.uuid = this.$route.query.uuid
      this.uid = this.$route.query.uid
      this.urlly = this.$route.query.urlly
      this.asstsQueryNow()
    }
  },
  methods: {
    fxfriedn: function () {
      this.popoverStatus = true
    },
    quit: function () {
      this.popoverStatus = false
    },
    xsclearbutton: function () {
      this.clearbutton = true
    },
    ycclearbutton: function () {
      this.clearbutton = false
    },
    clearInputValue: function () {
      this.$refs.bjNameIuput.value = ''
    },
    quitbjbox: function () {
      this.bjStatus = false
    },
    bjit: function () {
      this.bjStatus = true
    },
    openmessage: function (msg) {
      let _this = this
      this.TipStutasText = msg
      this.TipStutas = true
      setTimeout(function () {
        _this.TipStutasText = ''
        _this.TipStutas = false
      }, 2000)
    },
    asstsQueryNow: function () {
      let _this = this
      callApi({
        method: 'get',
        url: Config.path + '/fbeeapi/asset/queryHistoryById',
        headers: {uuid: this.uuid, versioncode: 1.0, platform: 'smallprogram', uid: this.uid, token: this.token},
        params: {id: this.cxAsstsId}
      }, (response) => {
        let list = response.data.content.assetInfo
        let mm1 = _.remove(list, function (o) {
          if (o.price !== '0') {
            return true
          } else {
            return false
          }
        })
        let mm2 = _.remove(list, function (o) {
          if (o.price !== '0') {
            return false
          } else {
            return true
          }
        })
        let list1 = _.reverse(_.sortBy(mm1, function (o) {
          o.usd = o.balance * o.price
          return o.usd
        }))
        let list2 = _.reverse(_.sortBy(mm2, function (o) {
          o.usd = o.balance * o.price
          return Number(o.balance)
        }))
        _this.tokenList = _.concat(list1, ...list2)
        _this.tagInfo = response.data.content.tagInfo
        _this.tagName = response.data.content.tagName
        let allp = 0
        for (let i = 0; i < _this.tokenList.length; i++) {
          _this.tokenList[i].key = i
          _this.tokenList[i].bs = _this.numberGsh(_this.tokenList[i].balance)
          allp += _this.tokenList[i].balance * _this.tokenList[i].price
        }
        _this.allprice = allp.toFixed(2)
        _this.loading2 = false
        _this.createTime = response.data.content.createTime
        _this.walletAddress = response.data.content.walletAddress
      }, this)
    },
    numberGsh: function (num) {
      let str = String(num)
      if (str.indexOf('.') > 0 && (str.length - str.indexOf('.')) > 5) {
        return str.slice(0, str.indexOf('.') + 5)
      } else {
        return str
      }
    },
    goTag: function () {
      let _this = this
      if (this.$refs.bjNameIuput.value === '') {
        return false
      }
      let params = {}
      let url = ''
      if (this.tagName === '') {
        url = '/fbeeapi/asset/remarkWalletAddress'
        params = {walletAddress: this.walletAddress, uid: this.uid, tagName: this.$refs.bjNameIuput.value}
      } else {
        url = '/fbeeapi/asset/alterWalletAddressRemark'
        params = {walletAddress: this.walletAddress, uid: this.uid, newTagName: this.$refs.bjNameIuput.value, oldTagName: this.tagName}
      }

      callApi({
        method: 'POST',
        url: Config.path + url,
        headers: {uuid: this.uuid, versioncode: 1.0, platform: 'smallprogram', uid: this.uid, token: this.token, 'Content-Type': 'application/x-www-form-urlencoded'},
        data: qs.stringify(params)
      }, (response) => {
        if (response.data.success === '1') {
          response.data.content === 1 ? _this.openmessage('标记成功，获得奖励次数') : _this.openmessage('标记成功')
          _this.loading2 = true
          _this.asstsQueryNow()
          _this.bjStatus = false
        } else {
          this.openmessage(response.data.message)
        }
      }, this)
    },
    getHtml2canvas: function () {
      this.jtmoshi = true
      this.loading2 = true
      this.popoverStatus = false
      this.tokenListBak = this.tokenList
      if (this.tokenList.length > 5) {
        this.tokenList = this.tokenList.slice(0, 5)
      }
      let _this = this
      setTimeout(() => {
        html2canvas(document.getElementById('lydom'), {backgroundColor: null}).then(function (canvas) {
          _this.tokenList = _this.tokenListBak
          _this.jtmoshi = true
          _this.openmessage('截图完成')
          let durl = canvas.toDataURL('image/png')
          _this.createJT(durl)
        })
      }, 3000)
    },
    createJT: function (url) {
      let _this = this
      let remToPx = document.documentElement.data_fsz
      let canvas = document.getElementById('canvas')
      let cxt = canvas.getContext('2d')
      canvas.width = 10 * remToPx * 4
      canvas.height = 21.653 * remToPx * 4
      let imageObjback = new Image()
      imageObjback.onload = function () {
        cxt.drawImage(imageObjback, 0, 0, canvas.width, canvas.height)
        if (_this.tagInfo.length !== 0) {
          cxt.font = 1.172 * remToPx + 'px PingFangSC-Medium'
          cxt.fillStyle = 'rgba(255,255,255,0.5)'
          cxt.textBaseline = 'top'
          let text3Top = 20.813 * remToPx * 4
          cxt.textAlign = 'center'
          cxt.fillText('长按识别小程序查询', canvas.width / 2, text3Top)
          cxt.font = 1.172 * remToPx + 'px PingFangSC-Medium'
          cxt.fillStyle = 'rgba(255,255,255,0.5)'
          cxt.textBaseline = 'top'
          let text1Top = 0.587 * remToPx * 4
          cxt.textAlign = 'center'
          cxt.fillText('该钱包地址被' + _this.tagInfo[0].count + '人标记为', canvas.width / 2, text1Top)
          cxt.font = 1.92 * remToPx + 'px PingFangSC-Medium'
          cxt.fillStyle = 'rgba(255,255,255)'
          cxt.textBaseline = 'top'
          let text2Top = 1.24 * remToPx * 4
          cxt.textAlign = 'center'
          cxt.fillText('"' + _this.tagInfo[0].name + '"', canvas.width / 2, text2Top)
          let imageObj = new Image()
          imageObj.onload = function () {
            cxt.drawImage(imageObj, 0, 2.347 * remToPx * 4, 10 * remToPx * 4, 18.28 * remToPx * 4)
            let durl = canvas.toDataURL('image/png')
            _this.imgDown = durl
            _this.loading2 = false
            _this.tpbjj = true
          }
          imageObj.src = url
        } else {
          cxt.font = 1.172 * remToPx + 'px PingFangSC-Medium'
          cxt.fillStyle = 'rgba(255,255,255,0.5)'
          cxt.textBaseline = 'top'
          let text3Top = 20.813 * remToPx * 4
          cxt.textAlign = 'center'
          cxt.fillText('长按识别小程序查询', canvas.width / 2, text3Top)
          let imageObj = new Image()
          imageObj.onload = function () {
            cxt.drawImage(imageObj, 0, 1.347 * remToPx * 4, 10 * remToPx * 4, 18.28 * remToPx * 4)
            let durl = canvas.toDataURL('image/png')
            _this.imgDown = durl
            _this.loading2 = false
            _this.tpbjj = true
          }
          imageObj.src = url
        }
      }
      imageObjback.src = '/static/backgroundZTx1.png'
    },
    imgLoad: function (event, index) {
      if (index < 5) {
        let canvas = document.createElement('canvas')
        canvas.width = event.target.width
        canvas.height = event.target.height
        let ctx = canvas.getContext('2d')
        ctx.drawImage(event.target, 0, 0, event.target.width, event.target.height)
        let dataURL = canvas.toDataURL('image/png')
        event.target.src = dataURL
      }
    },
    imgLoadError: function (event) {
      event.target.src = 'http://images.growup.link/tokenLogo/default.png'
    },
    share: function () {
      this.shareStutas = true
      this.popoverStatus = false
    },
    quitShare: function () {
      this.shareStutas = false
    },

    onCopy: function () {
      this.openmessage('复制成功')
    },

    onError: function () {
      this.openmessage('复制失败')
    }
  }
}
</script>

<style scoped>
  .box{
    background-image: url('http://images.growup.link/assts/image/backgroundZTx1.png');
    background-size: 100% auto;
    width: 100%;
    /*height: inherit;*/
    height: 100%;
    overflow: hidden;
    overflow-y: scroll;
  }
  .asstsCard{
    width: 9.0667rem;
    height: 3.7333rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 0.4rem;
    background-image: linear-gradient(-156deg, #2DA2FC 0%, #0372C7 96%);
    border-radius: 0.26667rem;
    box-shadow: 0 0.45rem 20px 0px #0000009c;
  }
  .asstsCard .asstsCardTitle{
    opacity: 0.5;
    font-family: PingFangSC-Medium;
    font-size: 0.4rem;
    color: #FFFFFF;
    position: absolute;
    left: 0.507rem;
    top: 0.56rem;
  }
  .asstsCard .asstsCardClick{
    font-family: PingFangSC-Semibold;
    font-size: 0.4rem;
    color: #FFFFFF;
    text-align: right;
    position: absolute;
    right: 0.507rem;
    top: 0.56rem;
  }
  .asstsCard .asstsCardClick span{
    opacity: 0.5;
    font-family: PingFangSC-Medium;
    color: #FFFFFF;
    text-align: right;
    margin-left: 0.1rem;
  }
  .asstsCard .asstsCardNum{
    /* 417245.06: */
    font-family: PingFangSC-Medium;
    font-size: 0.9333rem;
    color: #FFFFFF;
    letter-spacing: -0.0349rem;
    position: absolute;
    left: 0.507rem;
    top: 1.24rem;
  }
  .asstsCard .asstsCardNum span{
    /* USD: */
    opacity: 0.5;
    font-family: PingFangSC-Medium;
    font-size: 0.4rem;
    color: #FFFFFF;
    margin-left: 0.447rem;
  }
  .asstsCard .asstsCardAddres{
    /* 0x543E56a8923613D292: */
    opacity: 0.5;
    font-family: PingFangSC-Medium;
    font-size: 0.293rem;
    color: #FFFFFF;
    position: absolute;
    left: 0.507rem;
    top: 2.48rem;
    text-overflow: ellipsis;
    width: 8.0667rem;
    white-space: nowrap;
    overflow: hidden;
  }
  .asstsCard .asstsCardNowTips{
    opacity: 0.5;
    font-family: PingFangSC-Medium;
    font-size: 0.293rem;
    color: #FFFFFF;
    position: absolute;
    left: 0.507rem;
    top: 2.9733rem;
  }
  .dataUpdataTime{
    width: 9.0667rem;
    height: 0.5866rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    top: 4.733rem;
  }
  .dataUpdataTime p{
    font-family: PingFangSC-Regular;
    color: #6E7E91;
    font-size: 0.3733rem;
  }
  .dataUpdataTime a{
    font-family: PingFangSC-Regular;
    color: #4A90E2;
    font-size: 0.3733rem;
  }
  .B_list{
    width: 100%;
    position: absolute;
    top: 5.48rem;
    left: 0;
    overflow-x: hidden;
    overflow-y: scroll;
    height: calc(100vh - 5.48rem);
    min-height: 14rem;
  }
  .B_list>div{
    width: 100%;
    height: 2rem;
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
  }
  .B_list div img{
    width: 1.2rem;
    height: 1.2rem;
    display: block;
    position: absolute;
    left: 0.533rem;
    border-radius: 100%;
  }
  .B_list div .tipleft{
    position: absolute;
    left: 2.093rem;
  }
  .B_list div .tipleft p{
    font-family: PingFangSC-Regular;
    font-size: 0.48rem;
    color: #FFFFFF;
    text-align: left;
    text-overflow: ellipsis;
    width: 2.4rem;
    white-space: nowrap;
    overflow: hidden;
  }
  .B_list div .tipleft span{
    display: block;
    font-family: PingFangSC-Regular;
    font-size: 0.32rem;
    color: #6E7E91;
    text-align: left;
    text-overflow: ellipsis;
    width: 2.4rem;
    white-space: nowrap;
    overflow: hidden;
  }
  .B_list div .tipright{
    position: absolute;
    right: 0.533rem;
  }
  .B_list div .tipright p{
    font-family: PingFangSC-Regular;
    font-size: 0.48rem;
    color: #FFFFFF;
    text-align: right;
  }
  .B_list div .tipright span{
    display: block;
    font-family: PingFangSC-Regular;
    font-size: 0.32rem;
    color: #6E7E91;
    text-align: right;
  }
  .bottom_box1{
    width: 100%;
    height: 3.04rem;
    position: absolute;
    bottom: 0px;
    left: 0px;
    background: rgba(16,31,49,0.60);
    box-shadow: 0 -1px 1px 0 #061629;
    -webkit-filter: blur(0.2rem);
    -moz-filter: blur(0.2rem);
    -o-filter: blur(0.2rem);
    -ms-filter: blur(0.2rem);
    filter: blur(0.2rem);
    mix-blend-mode: luminosity;

  }
  .bottom_box{
    width: 100%;
    height: 3.04rem;
    position: fixed;
    bottom: 0px;
    left: 0px;
    background: rgba(16,31,49,0.60);
    box-shadow: 0 -1px 1px 0 #061629;
  }
  .downloadButton{
    font-family: PingFangSC-Regular;
    font-size: 0.373rem;
    color: #744A05;
    text-align: center;
    background-image: linear-gradient(-165deg, #FCEF22 0%, #FFDA28 100%);
    border-radius: 1.333rem;
    width: 7.467rem;
    height: 1.333rem;
    display: block;
    position: absolute;
    top: 0.467rem;
    line-height: 1.333rem;
    transform: translateX(-50%);
    left: 50%;
    z-index: 3;
    text-decoration: none;
  }
  .downloadButtonShadow{
    position: absolute;
    z-index: 2;
    width: 7.467rem;
    height: 1.733rem;
    left: 50%;
    transform: translateX(-50%);
    top: 0.467rem;
    border-radius: 1.3333rem;
  }
  .fxfriedn{
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: rgba(0,0,0,0.7);
    top: 0;
    left: 0;
    z-index: 10;
  }
  .fxfriedn .popover{
    position: absolute;
    width: 9.467rem;
    height: 4.8rem;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0.9333rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }
  .fxfriedn .popover .top{
    background: rgba(248,248,248,0.82);
    border-radius: 0.373rem;
    height: 3.053rem;
    width: 100%;
    overflow: hidden;
  }
  .fxfriedn .popover .top a{
    width: 100%;
    height: 1.52rem;
    font-family: PingFangSC-Medium;
    font-size: 0.533rem;
    color: #007AFF;
    letter-spacing: 1.5px;
    text-align: center;
    line-height: 1.52rem;
    display: block;
  }
  .fxfriedn .popover .bottom{
    background: rgba(255,255,255,1);
    border-radius: 0.373rem;
    height: 1.493rem;
    width: 100%;
    overflow: hidden;
  }
  .fxfriedn .popover .bottom a{
    width: 100%;
    height: 1.52rem;
    font-family: PingFangSC-Medium;
    font-size: 0.533rem;
    color: #007AFF;
    letter-spacing: 1.5px;
    text-align: center;
    line-height: 1.52rem;
    display: block;
  }
  .bj_box{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    background: rgba(0,0,0,0.7);
    z-index:20;
  }
  .bj_box>div{
    width: 7.333rem;
    height: 4.9333rem;
    position: absolute;
    background: #FFFFFF;
    border-radius: 0.26667rem;
    left: 50%;
    transform: translateX(-50%);
    top: 3.947rem;
  }
  .bj_box>div>.tip1{
    font-family: PingFangSC-Regular;
    font-size: 0.5333rem;
    color: #0A274A;
    text-align: center;
    position: absolute;
    top: 0.533rem;
    left: 50%;
    transform: translateX(-50%);
  }
  .bj_box>div>.tip2{
    font-family: PingFangSC-Regular;
    font-size: 0.3733rem;
    color: #9B9B9B;
    text-align: center;
    top: 1.387rem;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    width: 100%;
  }
  .bj_box>div>.bjNameIuput {
    top: 2.36rem;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    width: 6.4rem;
    height: 1.2rem;

  }
  .bj_box>div>.bjNameIuput>input{
    font-family: PingFangSC-Regular;
    font-size: 0.3733rem;
    color: #9B9B9B;
    top: 0rem;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    width: 5.4rem;
    height: 1.2rem;
    background: #F2F6FB;
    border-radius: 0.08rem;
    border: none;
    outline: none;
    color: #0A274A;
    padding-right: 1rem;
    text-indent: 0.2rem;
    letter-spacing: 0;
  }
  .bj_box>div>.bjNameIuput>a{
    position: absolute;
    z-index: 2;
    width: 0.2667rem;
    height: 0.2667rem;
    background-image: url("/static/clearinput.png");
    background-size: 100%;
    top: 50%;
    transform: translateY(-50%);
    right: 0.3rem;
  }
  .bj_box>div>.bottom_button{
    width: 100%;
    position: absolute;
    bottom: 0px;
    left: 0px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 1.2rem;
  }
  .bj_box>div>.bottom_button>a{
    display: block;
    width: 50%;
    height: 1.2rem;
    font-family: PingFangSC-Medium;
    font-size: 0.48rem;
    color: #229FFF;
    text-align: center;
    line-height: 1.2rem;
  }
  .successTip{
    opacity: 0.8;
    background: #000000;
    border-radius: 0.267rem;
    position: fixed;
    top: 7.147rem;
    left: 50%;
    transform: translateX(-50%);
    height: 2.66667rem;
    width: 5.333rem;
    font-family: PingFangSC-Regular;
    font-size: 0.427rem;
    color: #FFFFFF;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 1000
  }
  .canvas_box{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.7);
    z-index: 10001;
    overflow-y: scroll;
  }
  .canvas_box canvas{
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  .canvas_box img{
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 9.467rem;
  }
  .canvas_box .tipss{
    position: fixed;
    left: 50%;
    bottom: 30px;
    color: #fff;
    transform: translateX(-50%);
    padding: 5px 20px;
    background-color: rgba(0,0,0,0.7);
    border-radius: 20px;
  }
  #lydom{
    position: relative;
    width: 100%;
    height: 18.28rem;
    /*background-size: 100% auto;*/
    /*background-image: url("/static/backgroundZTx1.png");*/
    /*background-position: 1.148rem center;*/
  }
  .shareTip{
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 10000;
    background-color: rgba(0,0,0,0.6);
    top: 0px;
    left: 0px;
    background-image: url("/static/sharetip.png");
    background-position: right top;
    background-repeat: no-repeat;
    background-size: 4rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/asstsQuery.vue